module.exports = __webpack_public_path__ + "img/b9fdb6e89da4b215e18f34262ea0cca.05f5da67.png";